import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { 
  FaTruck, FaDownload, FaCheckCircle, FaUsers, FaShieldAlt, 
  FaChartLine, FaFileInvoiceDollar, FaWarehouse, FaCog, FaStar,
  FaArrowRight, FaShippingFast, FaCloud, FaDatabase, FaRoute, FaClock,
  FaChevronLeft,
  FaChevronRight,
  FaTimes
} from 'react-icons/fa';
import './SpediciaPage.css';
const SpediciaPage = () => {
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const [currentImageIndex, setCurrentImageIndex] = React.useState(0);
  const galleryImages = [
    '/spedicia/viber_image_2025-11-03_13-42-54-902.png',
    '/spedicia/android-chrome-512x512.png'
  ];
  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const features = [
    {
      icon: FaShippingFast,
      title: 'Sledovanie zásielok',
      description: 'Kompletné sledovanie zásielok v reálnom čase s automatickými notifikáciami'
    },
    {
      icon: FaTruck,
      title: 'Správa vozového parku',
      description: 'Evidencia vozidiel, servisné záznamy, automatické upozornenia na údržbu'
    },
    {
      icon: FaRoute,
      title: 'Optimalizácia trás',
      description: 'Pokročilé plánovanie trás, výpočet najkratších ciest a optimalizácia nákladov'
    },
    {
      icon: FaWarehouse,
      title: 'Skladové operácie',
      description: 'Pokročilé riadenie skladu, príjem a výdaj tovaru, inventúry'
    },
    {
      icon: FaShieldAlt,
      title: 'Bezpečnosť prepravy',
      description: 'Monitorovanie bezpečnosti, GPS sledovanie a ochrana nákladu'
    },
    {
      icon: FaCog,
      title: 'Flexibilné nastavenie',
      description: 'Prispôsobenie systému podľa špecifických potrieb vašej logistickej firmy'
    }
  ];

  const benefits = [
    {
      icon: FaChartLine,
      title: 'Zvýšenie efektivity',
      value: '40%',
      description: 'Automatizácia logistických procesov'
    },
    {
      icon: FaClock,
      title: 'Úspora času',
      value: '60%',
      description: 'Pri spracovaní objednávok a faktúr'
    },
    {
      icon: FaTruck,
      title: 'Presnosť doručenia',
      value: '99%',
      description: 'Eliminovanie chýb v doručovaní'
    },
    {
      icon: FaUsers,
      title: 'Spokojnosť klientov',
      value: '95%',
      description: 'S používaním systému Spedícia'
    }
  ];

  const packages = [
    {
      name: 'Spedícia BASIC',
      price: '299€',
      description: 'Ideálne pre malé prepravné firmy a živnostníkov',
      features: [
        'Základná logistika',
        'Faktúry a dodacie listy',
        'Evidencia vozidiel',
        'Základné reporty',
        '1 používateľ',
        'Email podpora'
      ]
    },
    {
      name: 'Spedícia STANDARD',
      price: '599€',
      description: 'Komplexné riešenie pre stredné logistické firmy',
      features: [
        'Všetky funkcie BASIC',
        'GPS sledovanie vozidiel',
        'Optimalizácia trás',
        'Pokročilé reporty',
        'Do 5 používateľov',
        'Online prístup',
        'Prioritná podpora'
      ],
      popular: true
    },
    {
      name: 'Spedícia PREMIUM',
      price: '999€',
      description: 'Enterprise riešenie pre veľké logistické spoločnosti',
      features: [
        'Všetky funkcie STANDARD',
        'CRM systém',
        'Business intelligence',
        'API integrácie',
        'Neobmedzený počet používateľov',
        'Podpora 24/7',
        'Onsite školenia'
      ]
    }
  ];

   const openModal = (imageSrc) => {
    const index = galleryImages.indexOf(imageSrc);
    setCurrentImageIndex(index);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

    const nextImage = () => {
    setCurrentImageIndex((prev) => (prev + 1) % galleryImages.length);
  };

  const prevImage = () => {
    setCurrentImageIndex((prev) => (prev - 1 + galleryImages.length) % galleryImages.length);
  };

  const industries = [
    {
      icon: FaTruck,
      title: 'Malé a stredné dopravné firmy',
      description: 'Komplexná logistika pre rastúce prepravné spoločnosti'
    },
    {
      icon: FaWarehouse,
      title: 'Logistické spoločnosti',
      description: 'Riadenie skladov a distribučných centier'
    },
    {
      icon: FaUsers,
      title: 'Spediční služby',
      description: 'Sprostredkovanie prepravy a logistické poradenstvo'
    },
    {
      icon: FaCloud,
      title: 'E-commerce logistika',
      description: 'Flexibilné riešenia pre online obchody a doručovanie'
    }
  ];

  const testimonials = [
    {
      name: 'Ing. Marián Kováč',
      company: 'TRANS-SPEED s.r.o.',
      text: 'Spedícia nám úplne zmenila spôsob práce s logistikou. Všetko je prehľadnejšie a rýchlejšie.',
      rating: 5
    },
    {
      name: 'Peter Novák',
      company: 'CARGO PLUS',
      text: 'Používame Spedíciu už 5 rokov a sme maximálne spokojní. Výborná podpora a pravidelné aktualizácie.',
      rating: 5
    }
  ];

  return (
    <div className="spedicia-page">
      {/* Hero Section */}
      <section className="spedicia-hero">
        <div className="container">
          <div className="hero-content">
            <div className="hero-text">
              <h1>Špedícia</h1>
              <h2>Komplexný informačný systém pre logistické firmy</h2>
              <p>
                Najnovšia verzia obľúbeného spedičného programu Špedícia vám prináša 
                nové, príjemnejšie užívateľské prostredie a rad ďalších noviniek. 
                Ideálne riešenie pre malé, stredné aj veľké logistické firmy s kompletným 
                sledovaním zásielok, správou vozového parku a optimalizáciou trás.
              </p>
              <div className="hero-actions">
                <Link to="/kontakt" className="btn btn-primary">
                  <FaArrowRight /> Žiadosť o ponuku
                </Link>
              </div>
            </div>
            <div className="hero-image">
              <img src="/spedicia.png" alt="Špedicia" className="hero-product-image" />
            </div>
          </div>
        </div>
      </section>

            {/* Gallery Section */}
      <section className="gallery-section">
        <div className="container">
          <h2>Ukážky systému</h2>
          <div className="gallery-grid">
            <div className="gallery-item" onClick={() => openModal('/spedicia/viber_image_2025-11-03_13-42-54-902.png')}>
              <img src="/spedicia/viber_image_2025-11-03_13-42-54-902.png" alt="špedicia - ukážka 1" />
            </div>
            <div className="gallery-item" onClick={() => openModal('/spedicia/android-chrome-512x512.png')}>
              <img src="/spedicia/android-chrome-512x512.png" alt="špedicia - ukážka 2" />
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="features-section">
        <div className="container">
          <h2>Pokročilé funkcie systému</h2>
          <div className="features-grid">
            {features.map((feature, index) => (
              <div key={index} className="feature-card">
                <div className="feature-icon">
                  <feature.icon />
                </div>
                <h4>{feature.title}</h4>
                <p>{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="benefits-section">
        <div className="container">
          <h2>Výsledky, ktoré môžete očakávať</h2>
          <div className="benefits-grid">
            {benefits.map((benefit, index) => (
              <div key={index} className="benefit-card">
                <div className="benefit-icon">
                  <benefit.icon />
                </div>
                <div className="benefit-value">{benefit.value}</div>
                <h4>{benefit.title}</h4>
                <p>{benefit.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Industries Section */}
      <section className="industries-section">
        <div className="container">
          <h2>Vhodné pre všetky typy logistických spoločností</h2>
          <div className="industries-grid">
            {industries.map((industry, index) => (
              <div key={index} className="industry-card">
                <div className="industry-icon">
                  <industry.icon />
                </div>
                <h4>{industry.title}</h4>
                <p>{industry.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Pricing Section */}
      <section className="pricing-section">
        <div className="container">
          <h2>Cenové balíčky</h2>
          <div className="pricing-grid">
            {packages.map((pkg, index) => (
              <div key={index} className={`pricing-card ${pkg.popular ? 'popular' : ''}`}>
                {pkg.popular && <div className="popular-badge">Najpopulárnejší</div>}
                <h3>{pkg.name}</h3>
                <div className="price">{pkg.price}</div>
                <p className="price-description">{pkg.description}</p>
                <ul className="features-list">
                  {pkg.features.map((feature, fIndex) => (
                    <li key={fIndex}>
                      <FaCheckCircle />
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
                <button className="btn btn-primary">
                  Vybrať balíček
                </button>
              </div>
            ))}
          </div>
        </div>
      </section>

       {/* Image Modal */}
      {isModalOpen && (
        <div className="image-modal" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={closeModal}>
              <FaTimes />
            </button>
            <button className="modal-prev" onClick={prevImage}>
              <FaChevronLeft />
            </button>
            <img 
              src={galleryImages[currentImageIndex]} 
              alt={`FastFood POS - ukážka ${currentImageIndex + 1}`}
            />
            <button className="modal-next" onClick={nextImage}>
              <FaChevronRight />
            </button>
            <div className="modal-counter">
              {currentImageIndex + 1} / {galleryImages.length}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SpediciaPage;
